export const extractAndFormatDate = (input: string) => {
  if (!input) return '';
  const dateRegexText = /([A-Za-z]+) (\d{1,2}), (\d{4})/;
  const matchText = input.match(dateRegexText);

  if (matchText) {
    const month = matchText[1];
    const day = matchText[2];
    const year = matchText[3];

    const monthMap = {
      January: 1,
      February: 2,
      March: 3,
      April: 4,
      May: 5,
      June: 6,
      July: 7,
      August: 8,
      September: 9,
      October: 10,
      November: 11,
      December: 12
    };

    const numericMonth = monthMap[month as keyof typeof monthMap];
    const formattedDate = `${year}-${numericMonth.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}T21:00:00.000Z`;
    return formattedDate;
  }

  const dateRegexNumeric = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
  const matchNumeric = input.match(dateRegexNumeric);

  if (matchNumeric) {
    const month = matchNumeric[1];
    const day = matchNumeric[2];
    const year = matchNumeric[3];

    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}T21:00:00.000Z`;
    return formattedDate;
  }

  return '';
};
